import React from 'react';

//MUI
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { Container } from '@mui/system';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';

//Images
import im2 from '../../assets/images/SDG/2.jpg';
import im7 from '../../assets/images/SDG/7.jpg';
import im9 from '../../assets/images/SDG/9.jpg';
import im10 from '../../assets/images/SDG/10.jpg';
import im11 from '../../assets/images/SDG/11.jpg';
import im13 from '../../assets/images/SDG/13.jpg';
import im14 from '../../assets/images/SDG/14.jpg';
import im15 from '../../assets/images/SDG/15.jpg';
import im17 from '../../assets/images/SDG/17.jpg';
import bg from '../../assets/images/background.svg'
import P7 from '../../assets/images/cardImages/regulatory.jpg';
import P7_small from '../../assets/images/cardImages/mobile/regulatory.jpg';
import WestIcon from '@mui/icons-material/West';
import EastIcon from '@mui/icons-material/East';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

const StyledBox = styled(Box)`
  ${({ theme }) => `
  cursor: pointer;
  transition: ${theme.transitions.create(['transform'], {
    duration: theme.transitions.duration.standard,
})};
  &:hover {
    transform: scale(1.8);
  }
  `}
`;



const Sectionc7 = () => {
    const [expanded1, setExpanded1] = React.useState(false);
    const handleExpandClick1 = () => {
        setExpanded1(!expanded1);
    };

    const [expanded2, setExpanded2] = React.useState(false);
    const handleExpandClick2 = () => {
        setExpanded2(!expanded2);
    };

    const [expanded3, setExpanded3] = React.useState(false);
    const handleExpandClick3 = () => {
        setExpanded3(!expanded3);
    };

    const [expand, setExpand] = React.useState(false);
    const expandAll = () => {
        setExpand(true);
        setExpanded1(true);
        setExpanded2(true);
        setExpanded3(true);
    };
    const closeAll = () => {
        setExpand(false);
        setExpanded1(false);
        setExpanded2(false);
        setExpanded3(false);
    };

    return (
        <Container>
            <Box mt={3} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button startIcon={<WestIcon />} sx={{ fontWeight: 'bold' }} href='/sectionc6'>
                    Previous
                </Button>
                <Button endIcon={<EastIcon />} sx={{ fontWeight: 'bold' }} href='/sectionc8'>
                    Next
                </Button>
            </Box>
            <Box mt={3} sx={{
                display: 'flex',
                alignItems: 'center',
                height: { xs: '150px', md: '300px' },
                backgroundImage: `url(${bg})`,
                backgroundSize: 'cover',
                borderRadius: '8px'
            }}>
                <Box px={5} py={3} sx={{ width: '100%' }}>
                    <Typography sx={{ typography: { xs: 'h5', md: 'h4' }, color: "#ffffff" }}>
                        Principle 7
                    </Typography>
                    <Typography mt={2} sx={{ typography: { xs: 'body1', md: 'h6' }, color: "#ffffff" }}>
                        Regulatory Policy
                    </Typography>
                    <Box mt={2} sx={{ display: { xs: 'none', lg: 'flex' } }}>
                        <Typography variant='body1' sx={{ color: "#ffffff" }}>
                            Businesses, when engaging in influencing public and regulatory policy,
                            should do so in a manner that is responsible and transparent
                        </Typography>
                    </Box>
                    <Box mt={3} sx={{ display: { xs: 'none', lg: 'flex' } }}>
                        <StyledBox><img src={im2} height="40" alt="svg" /> </StyledBox>
                        <StyledBox><img src={im7} height="40" alt="svg" /> </StyledBox>
                        <StyledBox><img src={im9} height="40" alt="svg" /> </StyledBox>
                        <StyledBox><img src={im10} height="40" alt="svg" /> </StyledBox>
                        <StyledBox><img src={im11} height="40" alt="svg" /> </StyledBox>
                        <StyledBox><img src={im13} height="40" alt="svg" /> </StyledBox>
                        <StyledBox><img src={im14} height="40" alt="svg" /> </StyledBox>
                        <StyledBox><img src={im15} height="40" alt="svg" /> </StyledBox>
                        <StyledBox><img src={im17} height="40" alt="svg" /> </StyledBox>
                    </Box>
                </Box>
                <Box sx={{
                    backgroundImage: {xs: `url(${P7_small})`, sm: `url(${P7})`},
                    backgroundSize: 'cover',
                    borderRadius: '0 8px 8px 0',
                    height: { xs: '150px', md: '300px' },
                    width: '100%'
                }}>
                </Box>
            </Box>

            <Box mt={5} sx={{ textAlign: "right" }}>
                <button onClick={!expand ? expandAll : closeAll} className="custom-button">
                    <span>
                        {!expand ? 'Expand All' : "Close All"}
                        {!expand ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                    </span>
                </button>
            </Box>
            <Box mt={3}>
                <Typography className='heading' variant='h4' sx={{ fontSize: '28px', color: "#e31837" }}>
                    Essential Indicators
                </Typography>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837", display: 'flex', lineHeight: { md: '36px' } }}>
                        1.
                        <ol type="a" style={{ margin: 0 }} >
                            <li>Number of affiliations with trade and industry chambers/ associations: <span style={{ color: "#000000", fontWeight: 100 }}>5</span></li>
                            <li>
                                List top 10 trade and industry chambers/ associations (determined based on the total members of such body) the entity is a member of/ affiliated to
                                <ExpandMore
                                    expand={expanded1}
                                    onClick={handleExpandClick1}
                                    aria-expanded={expanded1}
                                    aria-label="show more"
                                >
                                    <ExpandMoreIcon />
                                </ExpandMore>
                            </li>
                        </ol>
                    </Typography>
                </Box>
                <Collapse in={expanded1} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center"><strong>Sr. No</strong></TableCell>
                                        <TableCell align="left"><strong>Name of the trade and industry chambers/ associations</strong></TableCell>
                                        <TableCell align="center"><strong>Reach of trade and industry chambers/ associations (State/ National)</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" align='center'>1</TableCell>
                                        <TableCell align='left'>The Associated Chambers of Commerce and Industry of India (ASSOCHAM) </TableCell>
                                        <TableCell align='center'>National</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" align='center'>2</TableCell>
                                        <TableCell align='left'>Bombay Chamber of Commerce and Industry (BCCI)</TableCell>
                                        <TableCell align='center'>State</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" align='center'>3</TableCell>
                                        <TableCell align='left'>Confederation of Indian Industry (CII)</TableCell>
                                        <TableCell align='center'>National</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" align='center'>4</TableCell>
                                        <TableCell align='left'>Federation of Indian Chambers of Commerce & Industry (FICCI)</TableCell>
                                        <TableCell align='center'>National</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" align='center'>5</TableCell>
                                        <TableCell align='left'>Society of Indian Automobile Manufacturers (SIAM)</TableCell>
                                        <TableCell align='center'>National</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                        2. Provide details of corrective action taken or underway on any issues related to conduct by the entity, based on adverse orders from regulatory authorities
                        <ExpandMore
                            expand={expanded2}
                            onClick={handleExpandClick2}
                            aria-expanded={expanded2}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </ExpandMore>
                    </Typography>
                </Box>
                <Collapse in={expanded2} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center"><strong>Name of authority</strong></TableCell>
                                        <TableCell align="center"><strong>Brief of the case</strong></TableCell>
                                        <TableCell align="center"><strong>Corrective action taken</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align='center' colSpan={3}>Not Applicable</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={6}>
                <Typography className='heading' variant='h4' sx={{ fontSize: '28px', color: "#e31837" }}>
                    Leadership Indicators
                </Typography>
            </Box>
            <Box mt={2} mb={5} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                        1. Details of public policy positions advocated by the entity
                        <ExpandMore
                            expand={expanded3}
                            onClick={handleExpandClick3}
                            aria-expanded={expanded3}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </ExpandMore>
                    </Typography>
                </Box>
                <Collapse in={expanded3} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Box mb={2}>The Company pursues an active Public Affairs agenda by engaging with a range of stakeholders across Government, Think
                            Tanks, Climate Organizations, Trade Associations and Diplomatic Consulates to communicate its corporate position, address
                            policy related issues that are relevant to its strategy and help build thought leadership. </Box>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: { xs: 1200, md: 650 } }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center"><strong>Sr. No</strong></TableCell>
                                        <TableCell align="left"><strong>Public policy advocated </strong></TableCell>
                                        <TableCell align="left"><strong>Method resorted for such advocacy</strong></TableCell>
                                        <TableCell align="left"><strong>Whether information available in public domain? (Yes/ No)</strong></TableCell>
                                        <TableCell align="left"><strong>Frequency of Review by Board (Annually/ Half yearly/ Quarterly/ Others - please specify)</strong></TableCell>
                                        <TableCell align="left"><strong>Web Link, if available</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" align='center'>1</TableCell>
                                        <TableCell sx={{ maxWidth: 500 }} component="th" scope="row" align='left'>The Company engages with a range
                                            of stakeholders across Government,
                                            Think Tanks, Climate Organizations,
                                            Trade Associations and Diplomatic
                                            Consulates to communicate its
                                            corporate position, provide feedback
                                            and address policy related issues
                                            relevant to its businesses. The
                                            Company's approach is guided by
                                            its Code of Conduct which requires
                                            maintaining ethical business standards,
                                            anti-bribery and anti-corruption. Only
                                            authorised personnel can engage in
                                            commenting on political process or in
                                            policy debate.</TableCell>
                                        <TableCell sx={{ maxWidth: 500 }} component="th" scope="row" align='left'>Membership of leading industry
                                            associations such as CII, FICCI and
                                            ASSOCHAM and industry bodies
                                            such as SIAM; active participation in
                                            relevant Committees and Roundtables,
                                            stakeholder consultation and providing
                                            verbal and written proposals to
                                            Central and State Government
                                            departments. The Company operates
                                            with the principle of co-operating with
                                            Government, Chambers of Commerce
                                            and Trade Associations in matters
                                            concerning the industry, to promote,
                                            protect and enhance the Company's
                                            business interests.</TableCell>
                                        <TableCell component="th" scope="row" align='left'>No</TableCell>
                                        <TableCell component="th" scope="row" align='left'>NA</TableCell>
                                        <TableCell component="th" scope="row" align='left'>NA</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>
        </Container>
    )
}


export default Sectionc7;